var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9881 2.75311H11.6569V1.26123L1.25 2.86748V16.9469L11.6569 18.7394V16.5281H17.9881C18.1799 16.5378 18.3677 16.4712 18.5104 16.3428C18.6532 16.2145 18.7393 16.0348 18.75 15.8431V3.43748C18.7392 3.24589 18.653 3.06638 18.5102 2.93814C18.3675 2.80991 18.1798 2.74339 17.9881 2.75311ZM18.0881 15.9569H11.6356L11.625 14.7762H13.1794V13.4012H11.6131L11.6056 12.5887H13.1794V11.2137H11.5938L11.5863 10.4012H13.1794V9.02623H11.5813V8.21373H13.1794V6.83873H11.5813V6.02623H13.1794V4.65123H11.5813V3.40123H18.0881V15.9569Z",
    fill: "#20744A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0547 4.64935H16.7566V6.02435H14.0547V4.64935Z",
    fill: "#20744A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0547 6.83752H16.7566V8.21252H14.0547V6.83752Z",
    fill: "#20744A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0547 9.02563H16.7566V10.4006H14.0547V9.02563Z",
    fill: "#20744A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0547 11.2137H16.7566V12.5887H14.0547V11.2137Z",
    fill: "#20744A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0547 13.4019H16.7566V14.7769H14.0547V13.4019Z",
    fill: "#20744A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96656 6.67064L5.30781 6.59376L6.15094 8.91189L7.14719 6.49814L8.48844 6.42126L6.85969 9.71251L8.48844 13.0119L7.07031 12.9163L6.11281 10.4013L5.15469 12.8206L3.85156 12.7056L5.36531 9.79126L3.96656 6.67064Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.052ce080.svg";
export { ForwardRef as ReactComponent };